import ForgotPasswordContainer from "./ForgotPasswordContainer";
import ForgotPasswordStore from "./ForgotPasswordStore";

export default ForgotPasswordStore(ForgotPasswordContainer);